{
  "version": 1,
  "asset_id": "33be43f2-6086-4a28-9c1d-34c0d8afefca",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/33be43f2-6086-4a28-9c1d-34c0d8afefca/clip-img_2104.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/33be43f2-6086-4a28-9c1d-34c0d8afefca/clip-img_2104.mp4",
  "original_filename": "clip-img_2104.mp4",
  "size": 368303,
  "content_type": "video/mp4",
  "created_at": "2026-08-01T22:32:45Z"
}
